import React from 'react';
import ProjectsGraphQlController from '../../../controllers/projectsGraphQl';
import _ from 'lodash';
import LoadingBar from '../../components/global/loadingBar';
import Modal from '../../components/modals';
import moment from 'moment';
import { withRouter } from '../../../services/withRoute';
import { ReactComponent as MoreIconNew } from '../../../assets/svg/more-icon.svg';
import { ReactComponent as FullScreen } from '../../../assets/svg/small-screen.svg';
import { ReactComponent as Info } from '../../../assets/svg/info-icon.svg';
import { ReactComponent as CrossIcon } from '../../../assets/svg/cross.svg';
import { ReactComponent as CrossIcon3 } from '../../../assets/svg/cross3.svg';
import { ReactComponent as CrossIcon2 } from '../../../assets/svg/white-cross.svg';
import { ReactComponent as TickIcon } from '../../../assets/svg/expense-tick.svg';
import { gql } from '@apollo/client';

const mcLogs = gql`
	query McTransactionLogs($filters: McTransactionListFiltersInput) {
		mcTransactionLogs(filters: $filters) {
			data {
				status
				releasedBy {
					id
					name
				}
				releasedAt
				qrCode
				isReceived
				id
				eventId
				eventName
				createdBy {
					id
					name
				}
				createdAt
				backupLogs {
					isVerified
					createdBy {
						id
						name
					}
					verifiedBy {
						id
						name
					}
				}
				projectId
				projectName
				isEmpty
				mcId
			}
			totalPages
			totalDocs
			limit
			currentPage
			hasNextPage
			hasPrevPage
			prevPage
			nextPage
		}
	}
`;
class MCTableFullScreen extends ProjectsGraphQlController {
	constructor() {
		super();
		this.state = {
			showMemoryCardDropdown: false,
			showMemoryCardAssignModal: false,
			showMemoryCardReceiveModal: false,
			showEquimentDropdown: false,
			showEquimentAssignModal: false,
			showEquimentReceiveModal: false,
			mcCurrFilter: '',
			isLoading: true,
			eventDetails: [],
		};
		this.memoryCardRef = React.createRef();
		this.memoryCardDropdownRef = React.createRef();
	}
	componentDidMount = async () => {
		this.setState({
			mcCurrFilter: this.props.mcCurrFilter,
		});

		let eventDetails = _.cloneDeep(this.props.eventDetails);

		let logIds = [];
		for (let i = 0; i < _.size(eventDetails.memoryCards); i++) {
			let mc = eventDetails.memoryCards[i];
			if (
				_.size(mc.backupLogs) > 0 &&
				(mc.subStatus === 'verificationPending' ||
					mc.subStatus === 'releasePending' ||
					mc.subStatus === 'ready')
			) {
				if (
					_.has(mc.backupLogs[_.size(mc.backupLogs) - 1], 'backupLogId') &&
					mc.backupLogs[_.size(mc.backupLogs) - 1].backupLogId
				) {
					logIds.push(mc.backupLogs[_.size(mc.backupLogs) - 1].backupLogId);
				}
			}

			if (mc.isRemapped === null || mc.isRemapped === false) {
				if (
					mc.subStatus === 'verificationPending' ||
					mc.subStatus === 'releasePending' ||
					(_.size(mc.backupLogs) > 0 && mc.subStatus === 'ready')
				) {
					for (let j = 0; j < _.size(mc.backupLogs); j++) {
						let backup = mc.backupLogs[j];

						if (_.has(backup, 'verifyLogId') && backup.verifyLogId) {
							logIds.push(backup.verifyLogId);
						}
					}
				}
			}
		}

		if (_.size(logIds) > 0) {
			let json = {
				filters: {
					ids: logIds,
					limit: 100000,
					page: 1,
					eventId: this.props.params.shootID,
					projectId: this.props.params.projectID,
				},
			};
			let res = false;
			res = await this.getMcLogsForFullView(mcLogs, json);
			if (res !== false) {
				for (let i = 0; i < _.size(eventDetails.memoryCards); i++) {
					let mc = eventDetails.memoryCards[i];
					if (
						_.size(mc.backupLogs) > 0 &&
						(mc.subStatus === 'verificationPending' ||
							mc.subStatus === 'releasePending' ||
							mc.subStatus === 'ready')
					) {
						if (
							_.has(mc.backupLogs[_.size(mc.backupLogs) - 1], 'backupLogId') &&
							mc.backupLogs[_.size(mc.backupLogs) - 1].backupLogId
						) {
							let backupLogId = mc.backupLogs[_.size(mc.backupLogs) - 1].backupLogId;
							let found = undefined;
							found = _.find(res, { id: backupLogId });
							if (found && _.has(found, 'createdAt')) {
								eventDetails.memoryCards[i].copiedAt = found.createdAt;
							}
						}
					}

					if (mc.isRemapped === null || mc.isRemapped === false) {
						if (
							mc.subStatus === 'verificationPending' ||
							mc.subStatus === 'releasePending' ||
							(_.size(mc.backupLogs) > 0 && mc.subStatus === 'ready')
						) {
							let latestVerifiedAt = 0;
							for (let j = 0; j < _.size(mc.backupLogs); j++) {
								let backup = mc.backupLogs[j];

								if (_.has(backup, 'verifyLogId') && backup.verifyLogId) {
									let verifyLogId = backup.verifyLogId;
									let found = undefined;
									found = _.find(res, { id: verifyLogId });
									if (
										found &&
										_.has(found, 'createdAt') &&
										found.createdAt &&
										found.createdAt > latestVerifiedAt
									) {
										latestVerifiedAt = found.createdAt;
									}
								}
							}
							if (latestVerifiedAt !== 0) {
								eventDetails.memoryCards[i].verifiedAt = latestVerifiedAt;
							}
						}
					}
				}
			}

			this.setState({
				isLoading: false,
				eventDetails,
			});
		} else {
			this.setState({
				isLoading: false,
				eventDetails,
			});
		}

		document.addEventListener('mousedown', this.handleClickOutside);
	};

	computeEventDetails = async (tempEvenDetails) => {
		let eventDetails = _.cloneDeep(tempEvenDetails);
		let logIds = [];
		for (let i = 0; i < _.size(eventDetails.memoryCards); i++) {
			let mc = eventDetails.memoryCards[i];
			if (
				_.size(mc.backupLogs) > 0 &&
				(mc.subStatus === 'verificationPending' ||
					mc.subStatus === 'releasePending' ||
					mc.subStatus === 'ready')
			) {
				if (
					_.has(mc.backupLogs[_.size(mc.backupLogs) - 1], 'backupLogId') &&
					mc.backupLogs[_.size(mc.backupLogs) - 1].backupLogId
				) {
					logIds.push(mc.backupLogs[_.size(mc.backupLogs) - 1].backupLogId);
				}
			}

			if (mc.isRemapped === null || mc.isRemapped === false) {
				if (
					mc.subStatus === 'verificationPending' ||
					mc.subStatus === 'releasePending' ||
					(_.size(mc.backupLogs) > 0 && mc.subStatus === 'ready')
				) {
					for (let j = 0; j < _.size(mc.backupLogs); j++) {
						let backup = mc.backupLogs[j];

						if (_.has(backup, 'verifyLogId') && backup.verifyLogId) {
							logIds.push(backup.verifyLogId);
						}
					}
				}
			}
		}

		if (_.size(logIds) > 0) {
			let json = {
				filters: {
					ids: logIds,
					limit: 100000,
					page: 1,
					eventId: this.props.params.shootID,
					projectId: this.props.params.projectID,
				},
			};
			let res = false;
			res = await this.getMcLogsForFullView(mcLogs, json);
			if (res !== false) {
				for (let i = 0; i < _.size(eventDetails.memoryCards); i++) {
					let mc = eventDetails.memoryCards[i];
					if (
						_.size(mc.backupLogs) > 0 &&
						(mc.subStatus === 'verificationPending' ||
							mc.subStatus === 'releasePending' ||
							mc.subStatus === 'ready')
					) {
						if (
							_.has(mc.backupLogs[_.size(mc.backupLogs) - 1], 'backupLogId') &&
							mc.backupLogs[_.size(mc.backupLogs) - 1].backupLogId
						) {
							let backupLogId = mc.backupLogs[_.size(mc.backupLogs) - 1].backupLogId;
							let found = undefined;
							found = _.find(res, { id: backupLogId });
							if (found && _.has(found, 'createdAt')) {
								eventDetails.memoryCards[i].copiedAt = found.createdAt;
							}
						}
					}

					if (mc.isRemapped === null || mc.isRemapped === false) {
						if (
							mc.subStatus === 'verificationPending' ||
							mc.subStatus === 'releasePending' ||
							(_.size(mc.backupLogs) > 0 && mc.subStatus === 'ready')
						) {
							let latestVerifiedAt = 0;
							for (let j = 0; j < _.size(mc.backupLogs); j++) {
								let backup = mc.backupLogs[j];

								if (_.has(backup, 'verifyLogId') && backup.verifyLogId) {
									let verifyLogId = backup.verifyLogId;
									let found = undefined;
									found = _.find(res, { id: verifyLogId });
									if (
										found &&
										_.has(found, 'createdAt') &&
										found.createdAt &&
										found.createdAt > latestVerifiedAt
									) {
										latestVerifiedAt = found.createdAt;
									}
								}
							}
							if (latestVerifiedAt !== 0) {
								eventDetails.memoryCards[i].verifiedAt = latestVerifiedAt;
							}
						}
					}
				}
			}
		}
		this.setState({
			isLoading: false,
			eventDetails,
		});
	};

	componentWillUnmount = () => {
		document.removeEventListener('mousedown', this.handleClickOutside);
	};
	componentWillReceiveProps = (nextProps) => {
		if (nextProps.mcCurrFilter !== this.state.mcCurrFilter) {
			this.setState({
				mcCurrFilter: nextProps.mcCurrFilter,
			});
		}
	};
	componentDidUpdate = (prevProps, prevState) => {
		if (!_.isEqual(this.props.eventDetails, prevProps.eventDetails)) {
			this.computeEventDetails(this.props.eventDetails);
		}
	};
	toggleEquipmentDropDown = (e) => {
		this.setState({
			showEquimentDropdown: !this.state.showEquimentDropdown,
		});
	};
	showEquimentAssignModal = (e) => {
		this.props.navigate(
			`/${this.props.params.vendorID}/shoots/${this.props.params.workspaceID}/${this.props.params.projectID}/${this.props.params.shootID}/assign-equipment`,
		);
	};
	showEquimentReceiveModal = (e) => {
		this.props.navigate(
			`/${this.props.params.vendorID}/shoots/${this.props.params.workspaceID}/${this.props.params.projectID}/${this.props.params.shootID}/receive-equipment`,
		);
	};
	toggleMemoryCardDropDown = (e) => {
		this.setState({
			showMemoryCardDropdown: !this.state.showMemoryCardDropdown,
		});
	};
	showMemoryCardAssignModal = (e) => {
		this.props.navigate(
			`/${this.props.params.vendorID}/shoots/${this.props.params.workspaceID}/${this.props.params.projectID}/${this.props.params.shootID}/assign-memory-card`,
		);
		// this.setState(
		// 	{
		// 		showMemoryCardAssignModal: !this.state.showMemoryCardAssignModal,
		// 	},
		// 	() => {
		// 		if (this.state.showMemoryCardAssignModal === false) {
		// 			this.handleReload();
		// 		}
		// 	},
		// );
	};
	showMemoryCardReceiveModal = (e) => {
		this.props.navigate(
			`/${this.props.params.vendorID}/shoots/${this.props.params.workspaceID}/${this.props.params.projectID}/${this.props.params.shootID}/receive-memory-card`,
		);
		// this.setState(
		// 	{
		// 		showMemoryCardReceiveModal: !this.state.showMemoryCardReceiveModal,
		// 	},
		// 	() => {
		// 		if (this.state.showMemoryCardReceiveModal === false) {
		// 			this.handleReload();
		// 		}
		// 	},
		// );
	};
	showRecordABackUpModal = (e) => {
		this.setState({
			showRecordABackUpModal: !this.state.showRecordABackUpModal,
		});
	};
	showReAssignMemoryCards = (e) => {
		this.setState({
			showReAssignMemoryCards: !this.state.showReAssignMemoryCards,
		});
	};

	showReAssignEquipments = (e) => {
		this.setState({
			showReAssignEquipments: !this.state.showReAssignEquipments,
		});
	};
	handleClickOutside = (event) => {
		if (
			this.memoryCardRef.current &&
			!this.memoryCardRef.current.contains(event.target) &&
			this.memoryCardDropdownRef.current &&
			!this.memoryCardDropdownRef.current.contains(event.target)
		) {
			this.setState({
				showMemoryCardDropdown: false,
			});
		}
	};
	handleCloseModal = () => {
		this.props.handleClose();
	};

	getNotReceivedCount = () => {
		let c = 0;
		if (this.state.eventDetails.memoryCards) {
			for (let i = 0; i < _.size(this.state.eventDetails.memoryCards); i++) {
				if (this.state.eventDetails.memoryCards[i].isReceived === false) {
					c += 1;
				}
			}
		}

		return c;
	};
	isVerfiedResult = (backuplogArray) => {
		if (_.size(backuplogArray) !== 0 && backuplogArray !== null) {
			for (let i = 0; i < _.size(backuplogArray); i++) {
				if (backuplogArray[i].isVerified === false) {
					return false;
				}
			}
			return true;
		}
		return false;
	};
	// isHdUsed = (hdId, backupLogs) => {
	// 	if (backupLogs !== null && backupLogs.length !== 0) {
	// 		for (let i = 0; backupLogs.length; i++) {
	// 			if (backupLogs[i].hddQrCode === hdId) {
	// 				return true;
	// 			}
	// 		}
	// 		return false;
	// 	}

	// 	return false;
	// };
	verifiedByNames = (backuplog) => {
		let res = '';
		let resArray = [];
		if (backuplog !== null && _.size(backuplog) !== 0) {
			for (let i = 0; i < _.size(backuplog); i++) {
				if (backuplog[i].verifiedBy !== null) {
					if (!resArray.includes(backuplog[i].verifiedBy.name)) {
						res += backuplog[i].verifiedBy.name;
						res += ',';
						resArray.push(backuplog[i].verifiedBy.name);
					}
				}
			}
		}
		return res === '' ? '' : res.substring(0, _.size(res) - 1);
	};
	// verifiedAtTimes = (backuplog) => {
	//   let res = '';
	// 	let resArray = [];
	// 	if (backuplog !== null && backuplog.length !== 0) {
	// 		for (let i = 0; i < backuplog.length; i++) {
	// 			if (backuplog[i].verifiedBy !== null) {
	// 				if (!resArray.includes(backuplog[i].verifiedBy.name)) {
	// 					res += backuplog[i].verifiedBy.name;
	// 					res += ',';
	// 					resArray.push(backuplog[i].verifiedBy.name);
	// 				}
	// 			}
	// 		}
	// 	}
	// 	return res === '' ? '' : res.substring(0, res.length - 1);
	// }
	copiedByNames = (backuplog) => {
		let res = '';
		let resArray = [];
		if (backuplog !== null && _.size(backuplog) !== 0) {
			for (let i = 0; i < _.size(backuplog); i++) {
				if (backuplog[i].createdBy !== null) {
					if (!resArray.includes(backuplog[i].createdBy.name)) {
						res += backuplog[i].createdBy.name;
						res += ',';
						resArray.push(backuplog[i].createdBy.name);
					}
				}
			}
		}
		return res === '' ? '' : res.substring(0, res.length - 1);
	};

	getAllAssignedToNames = () => {
		let arr = [];
		let newArr = [];
		if (this.state.eventDetails.memoryCards) {
			for (let i = 0; i < _.size(this.state.eventDetails.memoryCards); i++) {
				if (!arr.includes(this.state.eventDetails.memoryCards[i].userName)) {
					arr.push(this.state.eventDetails.memoryCards[i].userName);
				}
			}
			for (let i = 0; i < arr.length; i++) {
				let tc = 0;
				let rc = 0;
				for (let j = 0; j < _.size(this.state.eventDetails.memoryCards); j++) {
					if (this.state.eventDetails.memoryCards[j].userName === arr[i]) {
						tc += 1;
						if (this.state.eventDetails.memoryCards[j].isReceived === true) {
							rc += 1;
						}
					}
				}
				newArr.push({ name: arr[i], tc: tc, rc: rc });
			}
		}

		return newArr;
	};
	getReceivedCount = () => {
		let c = 0;
		if (
			this.state.eventDetails.memoryCards &&
			this.state.eventDetails.memoryCards.length !== 0
		) {
			let arr = this.state.eventDetails.memoryCards.filter((el) => el.isReceived === true);
			c = arr.length;
		}
		return c;
	};

	render() {
		return (
			<Modal
				handleClose={() => this.handleCloseModal()}
				show={this.props.show}
				modalType={'center'}
				// isOverflowVisible={true}
			>
				<div className="busy-modal" style={{ width: '100vw', height: '100vh' }}>
					{this.state.isLoading === true ? (
						<LoadingBar />
					) : (
						<>
							<div className="bm-header3">
								<div
									style={{
										// padding: '20px 0',
										display: 'flex',
										flexDirection: 'column',
										width: '100%',
										gap: '10px',
									}}
								>
									<div
										style={{
											width: '100%',
											padding: '12px',
											display: 'flex',
											color: 'white',
											alignItems: 'center',
											gap: '70vw',
											justifyContent: 'space-between',
											// gap: '40vw',
										}}
									>
										<p style={{ fontSize: '18px' }}>
											MEMORY CARDS(
											{this.state.eventDetails.memoryCards
												? this.state.eventDetails.memoryCards.length
												: '0'}
											)
										</p>
										<div
											style={{
												disply: 'flex',
												alignItems: 'center',
												gap: '10px',
											}}
										>
											<FullScreen
												style={{
													height: '20px',
													width: '20px',
													marginRight: '15px',
													cursor: 'pointer',
												}}
												onClick={() => {
													this.props.handleClose();
												}}
											/>
											<span
												onClick={(e) => this.toggleMemoryCardDropDown(e)}
												ref={this.memoryCardRef}
											>
												<MoreIconNew
													style={{
														height: '20px',
														width: '20px',
														cursor: 'pointer',
													}}
												/>
											</span>
										</div>
									</div>
									<div
										className="shoot-page-sub-header-container2"
										style={{
											width: '100%',
											padding: '12px',
											display: 'flex',
											alignItems: 'center',
											gap: '10px',
											fontSize: '14px',
											flexWrap: 'wrap',
										}}
									>
										<div
											className={
												'sub-filter-item' +
												(this.state.mcCurrFilter === 'All' ? ' active' : '')
											}
											// style={{
											// 	padding: '8px 12px ',
											// 	borderRadius: '30px',
											// 	backgroundColor: '#6055EC',
											// 	color: 'white',
											// }}
											onClick={() => {
												if (this.state.mcCurrFilter !== 'All') {
													this.props.mcOnChangeFIlter('All');
												}
											}}
										>
											All{' '}
											{this.state.eventDetails.memoryCards &&
												this.state.eventDetails.memoryCards.length}
										</div>
										{this.getReceivedCount() > 0 ? (
											<div
												className={
													'sub-filter-item' +
													(this.state.mcCurrFilter === 'notReceived'
														? ' active'
														: '')
												}
												style={{
													// padding: '8px 12px ',
													// borderRadius: '30px',
													// backgroundColor: '#1C1C1C',
													color: '#CA5A4F',
												}}
												onClick={() => {
													if (this.state.mcCurrFilter !== 'notReceived') {
														this.props.mcOnChangeFIlter('notReceived');
													}
												}}
											>
												Not Received {this.getNotReceivedCount()}
											</div>
										) : (
											<></>
										)}
										{/* <p
									style={{
										padding: '8px 12px ',
										borderRadius: '30px',
										backgroundColor: '#1C1C1C',
										color: '#CA5A4F',
									}}
								>
									Not Received {this.getNotReceivedCount()}
								</p> */}
										{_.map(
											_.groupBy(
												_.sortBy(this.state.eventDetails.memoryCards, [
													'isReceived',
												]),
												'userId',
											),
											(item, userId) => {
												return (
													<div
														// style={{
														// 	padding: '8px 12px ',
														// 	borderRadius: '30px',
														// 	backgroundColor: '#1C1C1C',
														// 	color: '#B0B0B0',
														// 	cursor: 'pointer',
														// }}
														className={
															'sub-filter-item' +
															(this.state.mcCurrFilter === userId
																? ' active'
																: '')
														}
														onClick={() => {
															if (
																this.state.mcCurrFilter !== userId
															) {
																this.props.mcOnChangeFIlter(userId);
															}
														}}
													>
														<span className="title">
															{_.size(
																_.filter(
																	this.props.tenantUsersList,
																	{
																		id: userId,
																	},
																),
															) > 0
																? _.has(
																		_.filter(
																			this.props
																				.tenantUsersList,
																			{
																				id: userId,
																			},
																		)[0],
																		'displayName',
																  ) &&
																  _.filter(
																		this.props.tenantUsersList,
																		{
																			id: userId,
																		},
																  )[0]['displayName'] != null
																	? _.filter(
																			this.props
																				.tenantUsersList,
																			{
																				id: userId,
																			},
																	  )[0]['displayName']
																	: _.filter(
																			this.props
																				.tenantUsersList,
																			{
																				id: userId,
																			},
																	  )[0].firstName +
																	  ' ' +
																	  _.filter(
																			this.props
																				.tenantUsersList,
																			{
																				id: userId,
																			},
																	  )[0].lastName
																: ''}
															{' ' +
																_.size(
																	_.filter(
																		this.state.eventDetails
																			.memoryCards,
																		{
																			userId: userId,
																			isReceived: true,
																		},
																	),
																)}
															/{_.size(item)}
														</span>
														{/* <span className="title">
																	{_.size(item)}
																</span> */}
													</div>
												);
											},
										)}
										{/* <p
									style={{
										padding: '8px 12px ',
										borderRadius: '30px',
										backgroundColor: '#1C1C1C',
										color: '#B0B0B0',
									}}
								>
									Abhishek Chauhan 0/4
								</p>
								<p
									style={{
										padding: '8px 12px ',
										borderRadius: '30px',
										backgroundColor: '#1C1C1C',
										color: '#B0B0B0',
									}}
								>
									Sandeep Kollabathula 12/16
								</p> */}
									</div>
								</div>
							</div>
							<div
								style={{
									maxHeight: 'calc(100vh - 134px)',
									overflowY: 'scroll',
									width: '100%',
								}}
							>
								<table
									className="memoryCardSumaryTable3"
									style={{
										borderLeft: '0.5px solid  #383838',
										borderTop: '0.5px solid  #383838',
										color: 'white',
										width: '100%',
										// width: '48vw',
									}}
								>
									<thead
										style={{
											position: 'sticky',
											top: '0px',
										}}
									>
										<tr>
											<th
												style={{
													color: '#B0B0B0',
													textAlign: 'center',
													whiteSpace: 'nowrap',
												}}
											>
												S. NO
											</th>
											<th style={{ color: '#B0B0B0', whiteSpace: 'nowrap' }}>
												CARD TYPE
											</th>
											<th style={{ color: '#B0B0B0', whiteSpace: 'nowrap' }}>
												QR CODE
											</th>
											<th style={{ color: '#B0B0B0', whiteSpace: 'nowrap' }}>
												ASSIGNED BY
											</th>
											<th style={{ color: '#B0B0B0', whiteSpace: 'nowrap' }}>
												ASSIGNED AT
											</th>
											<th style={{ color: '#B0B0B0', whiteSpace: 'nowrap' }}>
												ASSIGNED TO
											</th>
											<th
												style={{
													color: '#B0B0B0',
													minWidth: '80px',
													textAlign: 'center',
													whiteSpace: 'nowrap',
												}}
											>
												RECEIVED
											</th>
											<th style={{ color: '#B0B0B0', whiteSpace: 'nowrap' }}>
												RECEIVED BY
											</th>
											<th style={{ color: '#B0B0B0', whiteSpace: 'nowrap' }}>
												RECEIVED FROM
											</th>
											<th style={{ color: '#B0B0B0', whiteSpace: 'nowrap' }}>
												RECEIVED AT
											</th>
											<th style={{ color: '#B0B0B0', whiteSpace: 'nowrap' }}>
												DATA IN GB
											</th>
											<th
												style={{
													color: '#B0B0B0',
													textAlign: 'center',
													whiteSpace: 'nowrap',
												}}
											>
												COPIES
											</th>
											<th
												style={{
													color: '#B0B0B0',
													textAlign: 'center',
													whiteSpace: 'nowrap',
												}}
											>
												VERIFIED
											</th>
											<th style={{ color: '#B0B0B0' }}>STATUS</th>
											{/* {this.state.eventDetails.hardDrives &&
										this.state.eventDetails.hardDrives.map((hd) => {
											return (
												<th style={{ color: '#B0B0B0' }}>{hd.qrCode}</th>
											);
										})} */}
											<th style={{ color: '#B0B0B0', whiteSpace: 'nowrap' }}>
												<p
													style={{
														display: 'flex',
														textAlign: 'center',
														gap: '5px',
														whiteSpace: 'nowrap',
													}}
												>
													<span>COPIED BY</span>
													<Info
														style={
															{
																// marginleft: '10px',
																// height: '20px',
																// width: '20px',
																// marginTop: '25px',
															}
														}
													/>
												</p>
											</th>

											<th style={{ color: '#B0B0B0', whiteSpace: 'nowrap' }}>
												<p
													style={{
														display: 'flex',
														alignItems: 'center',
														gap: '5px',
														whiteSpace: 'nowrap',
													}}
												>
													<span>COPIED AT{'  '}</span>
													<Info />
												</p>
											</th>
											<th
												style={{
													color: '#B0B0B0',
													whiteSpace: 'nowrap',
												}}
											>
												<p
													style={{
														display: 'flex',
														alignItems: 'center',
														gap: '5px',
														whiteSpace: 'nowrap',
													}}
												>
													<span>VERIFIED BY</span>
													<Info />
												</p>
											</th>
											<th style={{ color: '#B0B0B0', whiteSpace: 'nowrap' }}>
												<p
													style={{
														display: 'flex',
														alignItems: 'center',
														gap: '5px',
														whiteSpace: 'nowrap',
													}}
												>
													<span>VERIFIED AT</span>
													<Info />
												</p>
											</th>
											<th style={{ color: '#B0B0B0', whiteSpace: 'nowrap' }}>
												<p
													style={{
														display: 'flex',
														alignItems: 'center',
														gap: '5px',
														whiteSpace: 'nowrap',
													}}
												>
													<span>RELEASED BY</span>
													<Info />
												</p>
											</th>
											<th style={{ color: '#B0B0B0', whiteSpace: 'nowrap' }}>
												<p
													style={{
														display: 'flex',
														alignItems: 'center',
														gap: '5px',
														whiteSpace: 'nowrap',
													}}
												>
													<span>RELEASED AT</span>
													<Info />
												</p>
											</th>
										</tr>
									</thead>
									<tbody>
										{this.state.eventDetails.memoryCards &&
											_.map(
												this.state.mcCurrFilter === 'All'
													? _.sortBy(
															this.state.eventDetails.memoryCards,
															['isReceived', 'status', 'isEmpty'],
													  )
													: this.state.mcCurrFilter === 'notReceived'
													? _.filter(
															_.sortBy(
																this.state.eventDetails.memoryCards,
																['isReceived', 'status', 'isEmpty'],
															),
															{
																isReceived: false,
															},
													  )
													: _.filter(
															_.sortBy(
																this.state.eventDetails.memoryCards,
																['isReceived', 'status', 'isEmpty'],
															),
															{
																userId: this.state.mcCurrFilter,
															},
													  ),

												(el, idx) => {
													return (
														<tr
															onClick={() => {
																if (
																	el.isReceived == true &&
																	_.has(el, 'isRemapped') &&
																	(el.isRemapped === false ||
																		el.isRemapped === null)
																) {
																	this.props.handleOnCLickMC(el);
																}
															}}
															style={{
																cursor: 'pointer',
															}}
														>
															<td
																style={{
																	whiteSpace: 'nowrap',
																	textAlign: 'center',
																	textDecoration: el.isRemapped
																		? 'line-through'
																		: '',
																	color: el.isRemapped
																		? '#707070'
																		: '',
																	backgroundColor:
																		!el.isReceived &&
																		_.size(
																			_.filter(
																				this.props
																					.eventDetails
																					.memoryCards,
																				{
																					isReceived: true,
																				},
																			),
																		) > 0
																			? '#7A2915'
																			: '#121212',
																}}
															>
																{idx + 1}
															</td>
															<td
																style={{
																	whiteSpace: 'nowrap',
																	textDecoration: el.isRemapped
																		? 'line-through'
																		: '',
																	color: el.isRemapped
																		? '#707070'
																		: '',
																	backgroundColor:
																		!el.isReceived &&
																		_.size(
																			_.filter(
																				this.props
																					.eventDetails
																					.memoryCards,
																				{
																					isReceived: true,
																				},
																			),
																		) > 0
																			? '#7A2915'
																			: '#121212',
																}}
															>
																{el.type} ({el.size})
															</td>
															<td
																style={{
																	whiteSpace: 'nowrap',
																	textDecoration: el.isRemapped
																		? 'line-through'
																		: '',
																	color: el.isRemapped
																		? '#707070'
																		: '',
																	backgroundColor:
																		!el.isReceived &&
																		_.size(
																			_.filter(
																				this.props
																					.eventDetails
																					.memoryCards,
																				{
																					isReceived: true,
																				},
																			),
																		) > 0
																			? '#7A2915'
																			: '#121212',
																}}
															>
																{el.qrCode}
															</td>
															<td
																style={{
																	whiteSpace: 'nowrap',
																	textDecoration: el.isRemapped
																		? 'line-through'
																		: '',
																	color: el.isRemapped
																		? '#707070'
																		: '',
																	backgroundColor:
																		!el.isReceived &&
																		_.size(
																			_.filter(
																				this.props
																					.eventDetails
																					.memoryCards,
																				{
																					isReceived: true,
																				},
																			),
																		) > 0
																			? '#7A2915'
																			: '#121212',
																}}
															>
																{el.createdBy &&
																_.has(el.createdBy, 'name')
																	? el.createdBy.name
																	: ''}
															</td>
															<td
																style={{
																	whiteSpace: 'nowrap',
																	textDecoration: el.isRemapped
																		? 'line-through'
																		: '',
																	color: el.isRemapped
																		? '#707070'
																		: '',
																	backgroundColor:
																		!el.isReceived &&
																		_.size(
																			_.filter(
																				this.props
																					.eventDetails
																					.memoryCards,
																				{
																					isReceived: true,
																				},
																			),
																		) > 0
																			? '#7A2915'
																			: '#121212',
																}}
															>
																{el.createdAt
																	? moment
																			.unix(el.createdAt)
																			.format(
																				'DD/MM/YYYY,hh:mm a',
																			)
																	: ''}
															</td>
															<td
																style={{
																	whiteSpace: 'nowrap',
																	textDecoration: el.isRemapped
																		? 'line-through'
																		: '',
																	color: el.isRemapped
																		? '#707070'
																		: '',
																	backgroundColor:
																		!el.isReceived &&
																		_.size(
																			_.filter(
																				this.props
																					.eventDetails
																					.memoryCards,
																				{
																					isReceived: true,
																				},
																			),
																		) > 0
																			? '#7A2915'
																			: '#121212',
																}}
															>
																{el.userName}
															</td>

															<td
																style={{
																	textAlign: 'center',
																	whiteSpace: 'nowrap',
																	textDecoration: el.isRemapped
																		? 'line-through'
																		: '',
																	color: el.isRemapped
																		? '#707070'
																		: '',
																	backgroundColor:
																		!el.isReceived &&
																		_.size(
																			_.filter(
																				this.props
																					.eventDetails
																					.memoryCards,
																				{
																					isReceived: true,
																				},
																			),
																		) > 0
																			? '#7A2915'
																			: '#121212',
																}}
															>
																{' '}
																{el.isReceived ? (
																	<TickIcon />
																) : _.size(
																		_.filter(
																			this.state.eventDetails
																				.memoryCards,
																			{
																				isReceived: true,
																			},
																		),
																  ) > 0 ? (
																	<CrossIcon2
																		style={
																			{
																				// height: '35px',
																				// width: '35px',
																			}
																		}
																	/>
																) : (
																	<CrossIcon
																		style={{
																			height: '35px',
																			width: '35px',
																		}}
																	/>
																)}
															</td>
															<td
																style={{
																	whiteSpace: 'nowrap',
																	textDecoration: el.isRemapped
																		? 'line-through'
																		: '',
																	color: el.isRemapped
																		? '#707070'
																		: '',
																	backgroundColor:
																		!el.isReceived &&
																		_.size(
																			_.filter(
																				this.props
																					.eventDetails
																					.memoryCards,
																				{
																					isReceived: true,
																				},
																			),
																		) > 0
																			? '#7A2915'
																			: '#121212',
																}}
															>
																{el.receivedBy !== null
																	? el.receivedBy.name
																	: ''}
															</td>
															<td
																style={{
																	whiteSpace: 'nowrap',
																	textDecoration: el.isRemapped
																		? 'line-through'
																		: '',
																	color: el.isRemapped
																		? '#707070'
																		: '',
																	backgroundColor:
																		!el.isReceived &&
																		_.size(
																			_.filter(
																				this.props
																					.eventDetails
																					.memoryCards,
																				{
																					isReceived: true,
																				},
																			),
																		) > 0
																			? '#7A2915'
																			: '#121212',
																}}
															>
																{el.receivedFrom !== null
																	? el.receivedFrom.name
																	: ''}
															</td>
															<td
																style={{
																	whiteSpace: 'nowrap',
																	textDecoration: el.isRemapped
																		? 'line-through'
																		: '',
																	color: el.isRemapped
																		? '#707070'
																		: '',
																	backgroundColor:
																		!el.isReceived &&
																		_.size(
																			_.filter(
																				this.props
																					.eventDetails
																					.memoryCards,
																				{
																					isReceived: true,
																				},
																			),
																		) > 0
																			? '#7A2915'
																			: '#121212',
																}}
															>
																{el.receivedAt
																	? moment
																			.unix(el.receivedAt)
																			.format(
																				'DD/MM/YYYY,hh:mm a',
																			)
																	: ''}
															</td>
															<td
																style={{
																	whiteSpace: 'nowrap',
																	textDecoration: el.isRemapped
																		? 'line-through'
																		: '',
																	color: el.isRemapped
																		? '#707070'
																		: '',
																	backgroundColor:
																		!el.isReceived &&
																		_.size(
																			_.filter(
																				this.props
																					.eventDetails
																					.memoryCards,
																				{
																					isReceived: true,
																				},
																			),
																		) > 0
																			? '#7A2915'
																			: '#121212',
																}}
															>
																{el.isEmpty
																	? 'Empty'
																	: el.isRemapped
																	? ''
																	: el.backupLogs &&
																	  el.backupLogs.length > 0
																	? el.backupLogs[0]?.backupSize +
																	  ' GB'
																	: ''}
															</td>
															<td
																style={{
																	whiteSpace: 'nowrap',
																	textDecoration: el.isRemapped
																		? 'line-through'
																		: '',
																	color: el.isRemapped
																		? '#707070'
																		: '',
																	textAlign: 'center',
																	backgroundColor:
																		!el.isReceived &&
																		_.size(
																			_.filter(
																				this.props
																					.eventDetails
																					.memoryCards,
																				{
																					isReceived: true,
																				},
																			),
																		) > 0
																			? '#7A2915'
																			: '#121212',
																}}
															>
																{el.isRemapped
																	? ''
																	: el.backupLogs &&
																	  _.size(el.backupLogs) > 0
																	? _.size(el.backupLogs)
																	: ''}
															</td>
															<td
																style={{
																	whiteSpace: 'nowrap',
																	textDecoration: el.isRemapped
																		? 'line-through'
																		: '',
																	color: el.isRemapped
																		? '#707070'
																		: '',
																	textAlign: 'center',
																	backgroundColor:
																		!el.isReceived &&
																		_.size(
																			_.filter(
																				this.props
																					.eventDetails
																					.memoryCards,
																				{
																					isReceived: true,
																				},
																			),
																		) > 0
																			? '#7A2915'
																			: '#121212',
																}}
															>
																{!el.isReceived ? (
																	'-'
																) : this.isVerfiedResult(
																		el.backupLogs,
																  ) === true ? (
																	<TickIcon />
																) : (
																	<CrossIcon3
																		style={
																			{
																				// height: '30px',
																				// width: '30px',
																			}
																		}
																	/>
																)}
															</td>
															<td
																style={{
																	whiteSpace: 'nowrap',
																	textDecoration: el.isRemapped
																		? 'line-through'
																		: '',
																	color: el.isRemapped
																		? '#707070'
																		: '',
																	// textAlign: 'center',
																	backgroundColor:
																		!el.isReceived &&
																		_.size(
																			_.filter(
																				this.props
																					.eventDetails
																					.memoryCards,
																				{
																					isReceived: true,
																				},
																			),
																		) > 0
																			? '#7A2915'
																			: '#121212',
																}}
															>
																{el.isRemapped
																	? 'Reassigned'
																	: el.subStatus === null
																	? '-'
																	: el.subStatus === 'ready' &&
																	  el.isReceived === true
																	? 'Released'
																	: el.subStatus
																			.charAt(0)
																			.toUpperCase() +
																	  el.subStatus
																			.replace(
																				/([A-Z])/g,
																				' $1',
																			)
																			.slice(1)}
																{/* {el.subStatus} */}
															</td>
															{/* {this.state.eventDetails.hardDrives &&
														this.state.eventDetails.hardDrives.map(
															(hd) => {
																return (
																	<td
																		style={{
																			textAlign: 'center',
																			backgroundColor:
																				!el.isReceived &&
																				_.size(
																					_.filter(
																						this.props
																							.eventDetails
																							.memoryCards,
																						{
																							isReceived: true,
																						},
																					),
																				) > 0
																					? '#7A2915'
																					: '#121212',
																		}}
																	>
																		
																		{!el.isReceived ? (
																			'-'
																		) : el.backupLogs &&
																		  this.isHdUsed(
																				hd.qrCode,
																				el.backupLogs,
																		  ) === true ? (
																			<TickIcon />
																		) : (
																			<CrossIcon3 />
																		)}
																	</td>
																);
															},
														)} */}
															<td
																style={{
																	whiteSpace: 'nowrap',
																	textDecoration: el.isRemapped
																		? 'line-through'
																		: '',
																	color: el.isRemapped
																		? '#707070'
																		: '',
																	lineHeight: '150%',
																	backgroundColor:
																		!el.isReceived &&
																		_.size(
																			_.filter(
																				this.props
																					.eventDetails
																					.memoryCards,
																				{
																					isReceived: true,
																				},
																			),
																		) > 0
																			? '#7A2915'
																			: '#121212',
																}}
															>
																{this.copiedByNames(el.backupLogs)}
															</td>
															<td
																style={{
																	textDecoration: el.isRemapped
																		? 'line-through'
																		: '',
																	color: el.isRemapped
																		? '#707070'
																		: '',
																	whiteSpace: 'nowrap',
																	lineHeight: '150%',
																	backgroundColor:
																		!el.isReceived &&
																		_.size(
																			_.filter(
																				this.props
																					.eventDetails
																					.memoryCards,
																				{
																					isReceived: true,
																				},
																			),
																		) > 0
																			? '#7A2915'
																			: '#121212',
																}}
															>
																{el.isRemapped === true
																	? ''
																	: _.has(el, 'copiedAt')
																	? moment
																			.unix(el.copiedAt)
																			.format(
																				'DD/MM/YYYY, hh:mm a',
																			)
																	: ''}
															</td>
															<td
																style={{
																	textDecoration: el.isRemapped
																		? 'line-through'
																		: '',
																	color: el.isRemapped
																		? '#707070'
																		: '',
																	whiteSpace: 'nowrap',
																	backgroundColor:
																		!el.isReceived &&
																		_.size(
																			_.filter(
																				this.props
																					.eventDetails
																					.memoryCards,
																				{
																					isReceived: true,
																				},
																			),
																		) > 0
																			? '#7A2915'
																			: '#121212',
																	// lineHeight: '10px',
																	lineHeight: '150%',
																}}
															>
																{this.verifiedByNames(
																	el.backupLogs,
																)}
																{/* {el.verifiedBy !== null ? el.verifiedBy.name : ''} */}
															</td>
															<td
																style={{
																	textDecoration: el.isRemapped
																		? 'line-through'
																		: '',
																	color: el.isRemapped
																		? '#707070'
																		: '',
																	whiteSpace: 'nowrap',
																	lineHeight: '150%',
																	backgroundColor:
																		!el.isReceived &&
																		_.size(
																			_.filter(
																				this.props
																					.eventDetails
																					.memoryCards,
																				{
																					isReceived: true,
																				},
																			),
																		) > 0
																			? '#7A2915'
																			: '#121212',
																}}
															>
																{el.isRemapped === true ||
																!_.has(el, 'verifiedAt')
																	? ''
																	: moment
																			.unix(el.verifiedAt)
																			.format(
																				'DD/MM/YYYY, hh:mm a',
																			)}
															</td>
															<td
																style={{
																	textDecoration: el.isRemapped
																		? 'line-through'
																		: '',
																	color: el.isRemapped
																		? '#707070'
																		: '',
																	whiteSpace: 'nowrap',
																	backgroundColor:
																		!el.isReceived &&
																		_.size(
																			_.filter(
																				this.props
																					.eventDetails
																					.memoryCards,
																				{
																					isReceived: true,
																				},
																			),
																		) > 0
																			? '#7A2915'
																			: '#121212',
																}}
															>
																{el.releasedBy
																	? el.releasedBy.name
																	: ''}
															</td>
															<td
																style={{
																	whiteSpace: 'nowrap',
																	textDecoration: el.isRemapped
																		? 'line-through'
																		: '',
																	color: el.isRemapped
																		? '#707070'
																		: '',
																	backgroundColor:
																		!el.isReceived &&
																		_.size(
																			_.filter(
																				this.props
																					.eventDetails
																					.memoryCards,
																				{
																					isReceived: true,
																				},
																			),
																		) > 0
																			? '#7A2915'
																			: '#121212',
																}}
															>
																{el.releasedAt
																	? moment
																			.unix(el.releasedAt)
																			.format(
																				'DD/MM/YYYY, hh:mm a',
																			)
																	: ''}
															</td>
														</tr>
													);
												},
											)}
									</tbody>
								</table>
								{this.state.showMemoryCardDropdown ? (
									<div
										className=""
										style={{
											display: 'flex',
											flexDirection: 'column',
											// alignItems: 'center',
											padding: '15px',
											backgroundColor: 'white',
											color: 'black',
											borderRadius: '8px',
											// width: 'auto',
											width: '259px',
											fontWeight: '500',
											gap: '15px',
											position: 'absolute',
											zIndex: '99999999999999',
											marginBottom: '60%',
											marginLeft: '38vw',
											top: '30px',
											right: '30px',
										}}
										ref={this.memoryCardDropdownRef}
									>
										<a
											style={{
												cursor: 'pointer',
											}}
											onClick={(e) => this.showMemoryCardAssignModal(e)}
										>
											Assign Memory Cards
										</a>
										<a
											style={{
												cursor: 'pointer',
											}}
											onClick={(e) => this.showMemoryCardReceiveModal(e)}
										>
											Receive Memory Cards
										</a>
										<a
											style={{
												cursor: 'pointer',
											}}
											onClick={(e) => this.props.showRecordABackUpModal(e)}
										>
											Record a Backup
										</a>
										{false &&
										_.size(
											_.filter(this.state.eventDetails.memoryCards, {
												isReceived: false,
											}),
										) > 0 ? (
											<a
												style={{
													cursor: 'pointer',
												}}
												onClick={() => this.props.showReAssignMemoryCards()}
											>
												Reassign Memory Cards
											</a>
										) : null}
									</div>
								) : (
									''
								)}
							</div>
						</>
					)}
				</div>
			</Modal>
		);
	}
}
export default withRouter(MCTableFullScreen);
